import { render, staticRenderFns } from "./PluginConnection.vue?vue&type=template&id=8f23f904&scoped=true"
import script from "./PluginConnection.vue?vue&type=script&lang=js"
export * from "./PluginConnection.vue?vue&type=script&lang=js"
import style0 from "./PluginConnection.vue?vue&type=style&index=0&id=8f23f904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f23f904",
  null
  
)

export default component.exports